import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from "@angular/core";
import { DxDataGridComponent, DxSelectBoxComponent, DxTextBoxComponent } from "devextreme-angular";
import { custom } from "devextreme/ui/dialog";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import { LanguageService } from "../../../../../../../shared/services/language.service";
import { TimeService } from "../../../../../_api/services/time.service";
import { AmsNotifierService } from "../../../../../../../shared/services/ams-notifier.service";

@Component({
  selector: "app-edit-transport-transportarticle",
  templateUrl: "./edit-transport-transportarticle.component.html",
  styleUrls: ["./edit-transport-transportarticle.component.css"],
})
export class EditTransportTransportarticleComponent
  implements OnInit, OnChanges
{
  @ViewChild("datagriddx", { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('selectBoxRef', { static: false }) selectBox: DxSelectBoxComponent;
  @ViewChild(DxTextBoxComponent, { static: false }) searchEditor!: DxTextBoxComponent;
  @Input() gridDataSource: any;
  transportArticleDataSource: any;
  @Output() loading = new EventEmitter<boolean>(); //emit event to parent(project-portal.component) to show load indicator
  @Input() transport: any;
  @Output() changed = new EventEmitter();
  isEditingDisabled = false;
  transportArticles: any;
  validateTransportArticleMessage = this.languageService.LNG(
    "Label.Please.Select.Article"
  );

  newTransportArticle: any = {
    TransportArticleId: -1,
    Quantity: null,
  };

  constructor(
    public languageService: LanguageService,
    private timeService: TimeService,
    private amsNotifierService: AmsNotifierService
  ) {}

  isEmptyRow(row: any): boolean {
    return Object.values(row).every(value => value === undefined);
  }

  ngOnInit() {
    this.timeService.getTransportArticles().subscribe(
      (result: any) => {
        this.transportArticles = result.Data;
        this.transportArticleDataSource = new DataSource({
          store: new ArrayStore({
            data: result.Data,
            key: "TransportArticleId",
          }),
          group: "TransportMassTypeCode",
        });
      },
      (error) => {}
    );
  }

  ngOnChanges() {
    this.isEditingDisabled = this.transport.TransportStatusId >= 4;
  }

  onTransportArticleChanged(e, cell) {
    let sel = e.component.option("selectedItem");
    if (sel) {
      let data = {
        TransportArticleId: sel.TransportArticleId,
        Description: sel.Description,
        DisplayName: sel.DisplayName,
        TransportQuantityUnitId: sel.TransportQuantityUnitId,
        TransportQuantityUnitCode: sel.TransportQuantityUnitCode,
      };
      cell.setValue(data);
    } else {
      cell.setValue(null);
    }
  }

  setTransportArticleValue(newData, value) {
    newData.TransportArticleId = value.TransportArticleId;
    newData.Description = value.Description;
    newData.DisplayName = value.DisplayName;
    newData.TransportQuantityUnitId = value.TransportQuantityUnitId;
    newData.TransportQuantityUnitCode = value.TransportQuantityUnitCode;
  }

  onEditorPreparing(e) {
    if (e.parentType == "dataRow") {
      e.editorOptions.onFocusIn = function (args) {
        const input = args.element.querySelector(".dx-texteditor-input");
        if (input !== null && input !== undefined) {
          input.select();
        }
      };
    }
  }

  createNewArticle() {
    this.loading.emit(true);

    if (this.isValid()) {
      var quantity = this.newTransportArticle.Quantity?.toString().replace(
        ",",
        "."
      );
      let tca = {
        CarrierId: this.transport.CarrierId,
        TransportArticleId: this.newTransportArticle.TransportArticleId,
        Quantity: parseFloat(quantity),
        TransportStatusId: this.transport.TransportStatusId,
      };
      this.timeService.insertTransportArticle(tca).subscribe(
        (result: any) => {
          if (result.IsSuccess) {
            this.amsNotifierService.success(
              this.languageService.LNG("Label.SavedOK")
            );
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.errorWithTimeout(result.Message);
            }
            this.newTransportArticle = {
              TransportArticleId: -1,
              Quantity: null,
            };
            this.refresh();
            this.selectBox.instance.focus();
          } else {
            this.loading.emit(false);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        },
        (error) => {
          this.loading.emit(false);
        }
      );
    }

    this.loading.emit(false);
  }

  isValid(): boolean {
    let isValid: boolean = true;

    if (this.newTransportArticle.TransportArticleId < 0) {
      this.amsNotifierService.error(this.validateTransportArticleMessage);
      isValid = false;
    }

    return isValid;
  }

  refresh() {
    this.loading.emit(true);
    this.timeService
      .getTransportArticlesByTransportCollection(
        this.transport.TransportCollectionId
      )
      .subscribe(
        (result: any) => {
          this.loading.emit(false);
          if (result.IsSuccess) {
            this.gridDataSource = result.Data;
            this.changed.emit();
          } else {
            this.amsNotifierService.error(result.ErrorMessage);
          }
        },
        (error) => {
          this.loading.emit(false);
        }
      );
  }

  onRowUpdating(e) {
    const isCanceled = new Promise((resolve) => {
      this.loading.emit(true);
      for (var property in e.oldData) {
        if (!e.newData.hasOwnProperty(property)) {
          e.newData[property] = e.oldData[property];
        }
      }

      let keyCarrierId = e.key.CarrierId;
      let keyTransportArticleId = e.key.TransportArticleId;

      this.timeService
        .updateTransportArticle(
          keyCarrierId,
          keyTransportArticleId,
          e.newData.TransportArticleId,
          e.newData.Quantity
        )
        .subscribe(
          (result: any) => {
            this.loading.emit(false);
            if (result.IsSuccess) {
              resolve(false);
              this.amsNotifierService.success(
                this.languageService.LNG("Label.SavedOK")
              );
              if (result.Message != null && result.Message.length > 0) {
                this.amsNotifierService.errorWithTimeout(result.Message);
              }
              e.component.cancelEditData();
              this.refresh();
            } else {
              this.loading.emit(false);
              resolve(true);
              this.amsNotifierService.error(result.ErrorMessage);
            }
          },
          (error) => {
            this.loading.emit(false);
            resolve(true);
          }
        );
    
    });
    e.cancel = isCanceled;
  }

  onRowRemoving(e: any) {
    this.gridDataSource.splice(e.dataIndex, 1);
    let transportArticleIds: number[] = [];
    transportArticleIds.push(e.data.TransportArticleId); 
    this.loading.emit(true);
    
    this.timeService
      .deleteTransportArticleByTransportArticleIds(
        this.transport.CarrierId,
        transportArticleIds
      )
      .subscribe(
        (result: any) => {
          this.amsNotifierService.success(
            this.languageService.LNG("Label.DeletedOK")
          );
          if (result.Message != null && result.Message.length > 0) {
            this.amsNotifierService.error(result.Message);
          }
          this.loading.emit(false);
          this.refresh();
          this.dataGrid.selectedRowKeys = [];
        },
        (error) => {
          this.loading.emit(false);
        }
      );
  }
}
